<script setup lang="ts">
    import { SplideSlide } from '@splidejs/vue-splide';
    import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

    const props = defineProps<{ blok: SlideshowStoryblok }>();

    const extensions = { AutoScroll };

    const sliderOptions = computed(() => ({
        type: 'loop',
        direction: props.blok.rightToLeft ? 'ltr' : 'rtl',
        pagination: false,
        arrows: false,
        gap: '1rem',
        drag: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        autoScroll: {
            speed: 1.2,
            pauseOnHover: true
        },
        autoWidth: true
    }));
</script>
<template>
    <div class="slideshow-container">
        <LazySliderComponent
            :options="sliderOptions"
            :extensions="extensions"
        >
            <template #slides>
                <SplideSlide
                    v-for="element in props.blok.images"
                    :key="element.id"
                    class="slide"
                    :class="'--height-' + props.blok.height"
                >
                    <StoryblokImage
                        :media="element"
                        :type="props.blok.height ? `slideshow-${props.blok.height}` : 'slideshow'"
                        :alt="element.alt || ''"
                    />
                </SplideSlide>
            </template>
        </LazySliderComponent>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/pta-family/slideshow.scss';
</style>
